import React from 'react';
import './ConversationLifecycle.css';

export default function InactivityPrompt({noun,name,busy=false,onNew,onContinue}: {
  noun:'conversación'|'actividad';name?:string;busy?:boolean;onNew:()=>void;onContinue:()=>void;
}) {
  return <section className="retzia-lifecycle-card retzia-inactivity-prompt" aria-label={`${noun} anterior`}>
    <h2>¡Hola{name?.trim() ? `, ${name.trim()}` : ''}!</h2>
    <p>Qué gusto tenerte de vuelta. ¿Qué te gustaría practicar hoy?</p>
    <button disabled={busy} onClick={onNew}>Nueva {noun}</button>
    <button disabled={busy} onClick={onContinue}>Seguir donde me quedé</button>
    <p className="retzia-lifecycle-hint">Al empezar una nueva {noun}, la anterior dejará de estar disponible aquí.</p>
  </section>;
}
